import { addBreadcrumb } from '@sentry/browser';

export default () => (next) => (action) => {
  addBreadcrumb({ category: 'redux-action', message: action.type });
  next(action);
};
